import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export default function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="text-center">
        <p className="text-9xl font-bold text-gray-200 dark:text-gray-700">
          404
        </p>
        <h1 className="mt-4 text-3xl font-bold text-gray-900 dark:text-white">
          {t('notFound.title')}
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          {t('notFound.description')}
        </p>
        <Link to="/" className="btn btn-primary mt-6 inline-flex items-center">
          <Home className="mr-2 h-4 w-4" />
          {t('notFound.home')}
        </Link>
      </div>
    </div>
  )
}
